import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getLanguageDictionary() {
    return this.http.get(`${this.apiUrl}/Languages`);
  }
}
